import { IUserMini } from '../../../../ng2/shared/typings/interfaces/user.interface';

export interface IDocLogQuery {
  schoolId: string;
  docId?: string;
  userId?: string;
  collection?: string;
  loggedBefore?: string;
  loggedAfter?: string;
}

export interface IDocLogDiff {
  path: string;
  newVal: any;
  oldVal: any;
}

export interface IDocLog {
  _id: string;
  docId: string;
  diffs: IDocLogDiff[];
  createdBy: IUserMini;
  createdAt: string;
  schoolId: string;
  collection: string;
  type: string;
  newDoc?: any;
  studentId?: string;
  historyType?: string;
  metaData?: {
    fieldHuman?: string;
    pathName?: string;
    pathType?: 'COLLEGE' | 'CAREER';
    supportName?: string;
    flagType?: string;
    milestoneHuman?: string;
    activityName?: string;
    assessmentNickName?: string;
    adminNumber?: number;
  };
}

const nvUrlPart = '/v1/docLogs/:schoolId';
const paramDefaults = {
  schoolId: '@schoolId',
  docId: '@docId',
};
const actions = {};
const options = null;
const PERMISSIONING_MODEL_NAME = 'DOC_LOG';
const relationToUserPath = 'createdBy.userId';

export function DocLog(NvBaseModel, ErrorModal) {
  const DocLog = NvBaseModel(nvUrlPart, paramDefaults, actions, options, PERMISSIONING_MODEL_NAME, relationToUserPath);

  DocLog.parseParamsAndFetch = function(schoolId, params) {
    const query: IDocLogQuery = Object.assign({ schoolId }, params);

    return DocLog.query(query).$promise.catch(ErrorModal.show);
  };

  return DocLog;
}
